export var SsoLoginRequirement;
(function (SsoLoginRequirement) {
    SsoLoginRequirement["DISABLED"] = "no_sso";
    SsoLoginRequirement["ALLOWED"] = "sso_optional";
    SsoLoginRequirement["REQUIRED"] = "sso_required";
})(SsoLoginRequirement || (SsoLoginRequirement = {}));
